'use strict';

var getPaths = require('./getPaths.js');

function getKeysDeep(_) {
  return getPaths(_);
}

module.exports = getKeysDeep;



//////////////////
// WEBPACK FOOTER
// ./node_modules/deepdash/getKeysDeep.js
// module id = lJFF
// module chunks = 0